import { StageDefinition } from './StageDefinition';

export const stage01: StageDefinition = {
    platforms: [
        [46.45161290322581, 0],
        [81.29032258064515, 0],
        [116.1290322580645, 0],
        [150.96774193548387, 0],
        [185.80645161290326, 0],
        [220.64516129032265, 0],
        [255.48387096774204, 0],
        [290.3225806451614, 0],
        [325.1612903225808, 0],
    ],
    traps: [],
    stars: [
        [292, 2],
        [220, 2],
        [151, 2],
        [83, 2],
    ],
};
